<template>
  <div class="vx-row">
    <div class="w-full vx-col">

      <vx-card :title="'PRODUCTION CODES'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-production-codes-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="production-code-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="production_codes">
              <template slot="thead">
                <vs-th width="25%">PREFIX</vs-th>
                <vs-th width="25%">NAME</vs-th>
                <vs-th width="20%">FINISHED GOOD PRODUCT FORM</vs-th>
                <!-- <vs-th width="10%">PRINT ITEM PERCENTAGES IN WO LABEL</vs-th> -->
                <vs-th width="20%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].prefix">
                    {{ data[indextr].prefix }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_type">
                    {{ data[indextr].formulation_type || '-' }}
                  </vs-td>

                  <!-- <vs-td :data="data[indextr].show_formulation_percentage">
                    <vs-chip color="primary" v-if="data[indextr].show_formulation_percentage">Yes</vs-chip>
                  </vs-td> -->

                  <vs-td>
                    <div class="justify-start vx-row" v-can="'edit-production-codes-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr])"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>


                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <create-production-code-pop-up ref="createProductionCodePopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import CreateProductionCodePopUp from '@/components/popups/settings/production-codes/CreateProductionCodePopUp'

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  const ProductionCodeRepository = RepositoryFactory.get('production_code');

  export default {
    name: "ProductionCodesSettings",
    data() {
      return {
        production_codes: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      CreateProductionCodePopUp,
    },
    methods: {
      async refreshData() {
        await this.fetchProductionCodeLIst()
      },
      async fetchProductionCodeLIst() {
        await this.$vs.loading({
          container: '#production-code-list-table',
          scale: 0.45
        })
        const {data} = await ProductionCodeRepository.getListOfProductionCodes()
        this.production_codes =  data.data
        this.$vs.loading.close('#production-code-list-table > .con-vs-loading')
        if (this.$route.query.open) {
          const item = this.production_codes.find(c => c.id == this.$route.query.open)
          if (item) await this.$refs.createProductionCodePopUp.openPopup(item)
        }
      },
      async onClickAdd() {
        await this.$refs.createProductionCodePopUp.openPopup()
      },
      async onClickUpdate(data) {
        await this.$refs.createProductionCodePopUp.openPopup(data)
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      filterQueryUpdate (){
        this.fetchProductionCodeLIst()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProductionCodeLIst()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchProductionCodeLIst()
        }
      },
    },
    async mounted() {
      await this.fetchProductionCodeLIst()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchProductionCodeLIst()
      },
      perPage() {
        this.fetchProductionCodeLIst()
      }
    }
  }
</script>

<style scoped>

</style>
